import { cn } from '@ophelos/ui/lib/utils';

interface LoaderProps {
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | number;
}

const sizeMap = {
  xs: 12,
  sm: 16,
  md: 24,
  lg: 32,
  xl: 48,
};

export function Loader({ className, size = 'md' }: LoaderProps) {
  const pixelSize = typeof size === 'number' ? size : sizeMap[size];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={pixelSize}
      height={pixelSize}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn('animate-spin', className)}
    >
      <path d="M12 2v4" strokeOpacity="25%" />
      <path d="m16.2 7.8 2.9-2.9" strokeOpacity="25%" />
      <path d="M18 12h4" strokeOpacity="50%" />
      <path d="m16.2 16.2 2.9 2.9" strokeOpacity="50%" />
      <path d="M12 18v4" strokeOpacity="75%" />
      <path d="m4.9 19.1 2.9-2.9" strokeOpacity="75%" />
      <path d="M2 12h4" strokeOpacity="100%" />
      <path d="m4.9 4.9 2.9 2.9" strokeOpacity="100%" />
    </svg>
  );
}
